import { render, staticRenderFns } from "./modalTeguran.vue?vue&type=template&id=01066874&scoped=true"
import script from "./modalTeguran.vue?vue&type=script&lang=js"
export * from "./modalTeguran.vue?vue&type=script&lang=js"
import style0 from "./modalTeguran.vue?vue&type=style&index=0&id=01066874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01066874",
  null
  
)

export default component.exports